import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVesselOwner = () => {
  return axios.get(apiurl?.getVesselOwnerList);
};

const getVesselOwnerList = () => {
  return useQuery(['getVesselOwnerList'], () => getVesselOwner(), { refetchOnWindowFocus: false });
};

export default getVesselOwnerList;
